import {getWindowWidth} from "../../dev/js/core/Helpers/Helpers";

const onMobileImageReplace = () => {
    let mobileImages = [...document.querySelectorAll('.js-mob-version')];
    let suffix = "_mob";
    
    const setNewSrc = image => {
        if (!image.src.includes(suffix)) {
            let filename = image.src.slice(0, -4);
            let ext = image.src.substr(-4);
            image.node.setAttribute('src', `${filename}${suffix}${ext}`);
        }
    };
    
    const removeSuffix = image => {
        let newSrc = image.src.split(suffix).join("");
        image.node.setAttribute('src', newSrc);
    };
    
    const replaceImages = () => {
        
        mobileImages.forEach(image => {
            let imgObject = {
                node : image,
                src : image.getAttribute('src')
            };
            
            if (getWindowWidth() < 992){
                setNewSrc(imgObject);
            }else{
                removeSuffix(imgObject);
            }
        });
    };
    
    replaceImages('First');
    window.addEventListener('resize', debounce(replaceImages,200));
};

export default onMobileImageReplace;


// WEBPACK FOOTER //
// ../containers/vilpe/mobileImageReplace.js